import React from "react";
import AppFieldTitleConfig from "./app_field_title_config";
import "./app_field_title.css";

class AppFieldTitle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    //Available properties
    propFontColor() { return this.props.fontColor };
    propCompulsory() { return this.props.compulsory };
    propText() { return this.props.text };
    propSuffixCompulsory() {
        return this.props.suffixCompulsory;
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="mb-2">
                <small
                    id="IDLabel"
                    style={{
                        fontSize: "16px",
                        color: this.propFontColor() == AppFieldTitleConfig.fontColor.gray ? "#808ea8" : "#1D365E",
                    }}
                    className={
                        `${this.propFontColor() == AppFieldTitleConfig.fontColor.gray ? "form_normal_title_input" : "form_bold_title_input"}`
                    }
                >
                    {this.propCompulsory() == AppFieldTitleConfig.compulsory.true && this.propText() ? (
                        <span
                            style={{ marginRight: "2px", color: "#DA291C" }}
                        >
                            *
                        </span>
                    ) : null}{" "}
                    <span dangerouslySetInnerHTML={{
                    __html: this.propText(),
                  }}></span>
                    {this.propSuffixCompulsory() ? (
                        <span
                            style={{ marginRight: "2px", color: "#DA291C" }}
                        >
                         {` *`}
                        </span>
                    ) : null}{" "}
                </small>
            </div>
        );
    }
}

export default AppFieldTitle;
